// extracted by mini-css-extract-plugin
module.exports = {"container":"CRM_container__KAYbb","toolBar":"CRM_toolBar__2tRPz","qtdeRows":"CRM_qtdeRows__3x6kG","columnAction":"CRM_columnAction__16tzt"};